<script>
import { mapGetters } from 'vuex'
import { authComputed } from '@state/helpers'
import CartRooms from '@components/cart-rooms'
import CartExtras from '@components/cart-extras'

export default {
  components: { CartRooms, CartExtras },
  computed: {
    ...mapGetters('cart', ['searchParams', 'breakdown']),
    ...mapGetters('cart/rooms', { roomCartItems: 'cartItems' }),
    ...mapGetters('cart/extras', { extraCartItems: 'cartItems' }),
    ...authComputed,
  },
}
</script>

<template>
  <ul class="text-md leading-relaxed">
    <li class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Check-in</span>
        <span class="w-1/2 text-right">
          {{ searchParams.checkIn | cartDate }}
        </span>
      </div>
    </li>
    <li class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Check-out</span>
        <span class="w-1/2 text-right">
          {{ searchParams.checkOut | cartDate }}
        </span>
      </div>
    </li>
    <CartRooms
      v-for="(roomItem, roomItemIndex) in roomCartItems"
      :key="`room-${roomItemIndex}`"
      :item="roomItem"
    />
    <CartExtras
      v-for="(extraItem, extraItemIndex) in extraCartItems"
      :key="`extra-${extraItemIndex}`"
      :item="extraItem"
    />
    <li class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Total</span>
        <span class="w-1/2 text-right">
          <span class="text-sm mr-1">{{ breakdown.currency }}</span>
          <span>{{ breakdown.net | currency }}</span>
        </span>
      </div>
    </li>
    <li v-if="loggedIn" class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Member Discount</span>
        <span class="w-1/2 text-right">
          <span class="text-sm mr-1">- {{ breakdown.currency }}</span>
          <span>{{ breakdown.discount | currency }}</span>
        </span>
      </div>
    </li>
    <li class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Service</span>
        <span class="w-1/2 text-right">
          <span class="text-sm mr-1">{{ breakdown.currency }}</span>
          <span>{{ breakdown.service | currency }}</span>
        </span>
      </div>
    </li>
    <li class="border-b border-dotted mb-2 border-gray-400">
      <div class="flex flex-wrap">
        <span class="w-1/2">Tax</span>
        <span class="w-1/2 text-right">
          <span class="text-sm mr-1">{{ breakdown.currency }}</span>
          <span>{{ breakdown.tax | currency }}</span>
        </span>
      </div>
    </li>
    <li class="border-b border-dotted mb-2 border-gray-400 font-medium">
      <div class="flex flex-wrap">
        <span class="w-1/2 text-xl">Grand Total</span>
        <span class="w-1/2 text-right">
          <span class="text-sm mr-1">{{ breakdown.currency }}</span>
          <span class="text-xl">{{ breakdown.gross | currency }}</span>
        </span>
      </div>
    </li>
  </ul>
</template>
